// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip","message":"Tooltip_message","TooltipRight":"Tooltip_TooltipRight","icon":"Tooltip_icon"};